import Vue from 'vue';
import Vuex from 'vuex';
import applications from './applications';
import roles from './roles';
import users from './users';
import {getUserStore} from '@milkboxltd/common-components-frontend'

Vue.use(Vuex);

const projectName = process.env.VUE_APP_PROJECT_NAME || 'umbrella'
const user = getUserStore(process.env.VUE_APP_API_URL, projectName)

export default new Vuex.Store({
  state: {
    firstName: '',
    lastName: '',
  },
  modules: {
    users,
    roles,
    applications,
    user,
  },
});
